import { render, staticRenderFns } from "./Stats-Admin.vue?vue&type=template&id=704bd59a"
import script from "./Stats-Admin.js?vue&type=script&lang=js&external"
export * from "./Stats-Admin.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports